import React, {useState, useEffect} from 'react';
import QRCodeReader from 'react-qr-reader';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { DialogActions, Chip } from '@material-ui/core';
import { Grid, FormControl, InputLabel, Select } from '@material-ui/core';
import { sendGetRequest, sendPostRequest, sendDeleteRequest, sendPutRequest } from 'utils/api';
import DB from '../db';
import _ from 'lodash';
import BasicDropDown from './forms/formElements/toolsDropdown';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { validate } from '@material-ui/pickers';
 
function SearchRecords() { 

    // State Varialbes
    const [records, setRecords] = useState({})
    const [assetTag, setAssetTag] = useState('')

    const [errorDialog, setErrorDialog] = useState(false)
    const [QRCodeReaderDialog, setQRCodeReaderDialog] = useState(false)
    const [editDialog1, setEditDialog1] = useState(false)
    const [editDialog2, setEditDialog2] = useState(false)
    
    const [selectedAssetTag, setSelectedAssetTag] = useState('')
    const [selectedDepartment, setSelectedDepartment] = useState('')
    const [selectedBU, setSelectedBU] = useState('')
    const [selectedSource, setSelectedSource] = useState('')
    const [selectedAssignee, setSelectedAssignee] = useState('')
    const [selectedRemarks, setSelectedRemarks] = useState('')

    const [selectedSerialNum, setSelectedSerialNum] = useState('')
    const [selectedLocationID, setSelectedLocationID] = useState('')
    const [selectedUom, setSelectedUOM] = useState('')
    const [selectedDescription, setSelectedDescription] = useState('')
    const [selectedStatus, setSelectedStatus] = useState('')
    const [selectedCost, setSelectedCost] = useState('')

    const [famasDb, setFamasDb] = useState({
        db: new DB(),
        famas: {}
    });

    const [departments, setDepartments] = useState([]);
    const [businessUnits, setBusinessUnits] = useState([]);
    const [plantSite, setPlantSite] = useState([]);
    const [buildingStructure, setBuildingStructure] = useState([]);
    const [room, setRoom] = useState([]);

    const [tms, setTms] = useState([]);
    const [selectedTms, setSelectedTms] = useState([]);
    const [selectedFrom, setSelectedFrom] = useState([]);

    const [errorMessage, setErrorMessage] = useState();

    // Just pops the QRCode Reader Dialog
    function startScan(){
        setQRCodeReaderDialog(true)
    }

    useEffect(() => {

        if(!_.isEmpty(localStorage.getItem("depts"))){
            let tempItems = JSON.parse(localStorage.getItem("depts"));
            setDepartments(tempItems);
        }

        if(!_.isEmpty(localStorage.getItem("businessUnits"))){
            let tempItems = JSON.parse(localStorage.getItem("businessUnits"));
            setBusinessUnits(tempItems);
        }

        if(!_.isEmpty(localStorage.getItem("plantSite"))){
            let tempItems = JSON.parse(localStorage.getItem("plantSite"));
            setPlantSite(tempItems);
        }

        if(!_.isEmpty(localStorage.getItem("buildingStructure"))){
            let tempItems = JSON.parse(localStorage.getItem("buildingStructure"));
            setBuildingStructure(tempItems);
        }

        if(!_.isEmpty(localStorage.getItem("room"))){
            let tempItems = JSON.parse(localStorage.getItem("room"));
            setRoom(tempItems);
        }


        return () => {
            
        }
    }, [])
 
    useEffect(() => {
        
        if(tms && records.toUser){
            let toUser = records.toUser;
            let fromUser = records.fromUser;

            let objFrom = tms.find(x => x.id === fromUser);

            if(objFrom){
                setSelectedFrom(objFrom);
            }

            if(isJson(toUser)){
                //let obj = array.find(x => x.name === 'string 1');
    
                let items = JSON.parse(toUser);
                console.log("toUser values", items);
                console.log("tms", tms);
                let foundAssignee = [];

                for(let item of items){
                    let obj = tms.find(x => x.id === item.toUser);
                    if(obj){
                        console.log("Search employee ID", obj);
                        foundAssignee.push(obj);
                    }
                }   
                setSelectedTms(foundAssignee);
            }

        }
        
        return () => {
        
        }
    }, [tms, records])

    // Checks the result of the QRCode and check if its on localstorage, if not then it will fetch data from the 
    // Express SQL server, store it on localstorage, and check if QRCode result is existing on localstorage
    // if yes then display the result and if not, display error dialog
    //famas-records-header
    async function scanQRCode(result) {
        if(result != null){
            // console.log(result)
            // const response = await localStorage.getItem(result)
            // if(response === null){

            //     if(localStorage.length < 1) {
            //         const headerDataResponse = await sendGetRequest('/famas/header')
            //         const recordsData = await headerDataResponse.data[0].map((row)=>{return row})
            //         const finalRecords = []
            //         for(let i=0; i<recordsData.length; i++){
            //             finalRecords.push({
            //                 data: recordsData[i]
            //             })
            //         }
            //         finalRecords.map((row)=>{
            //             localStorage.setItem(row.data.asset_tag, JSON.stringify(row.data))
            //             return true
            //         })
            //         const lineData = await sendGetRequest('famas-records-line')
            //         await lineData.data[0].map((row1)=> {
            //             localStorage.setItem(row1.asset_tag, JSON.stringify(row1))
            //             return true
            //         })
            //         scanQRCode(result)
                    
            //     } else {
            //         setErrorDialog(true)
            //     }
                
            // } else {
            //     setRecords(JSON.parse(response))
            // }
            
            setQRCodeReaderDialog(false);
            
            searchRecordLocal(result);

        }  
    }
 
    function handleError(error) {
        console.log(error)
    }
    
    const isJson = async (p_string) =>{
        try{
            JSON.parse(p_string);
            return true;
        }catch{
            return false;
        }
    }
    
    //NEW FUNCTION
    async function searchRecordLocal(p_search) {
        
        if(!assetTag && !p_search)return;

        if(p_search){
            let resFind = await famasDb.db.searchByAssetTag(p_search);
            setRecords(resFind.docs[0]);
            return;
        }
            
        if(assetTag){
            let resFind = await famasDb.db.searchByAssetTag(assetTag);
            setRecords(resFind.docs[0]);
            return;
        }
        
    }

    // Same function with ScanQR Code but this time search the data from assetTag textfield 
    async function searchRecord() {
        console.log("SEARCHING")
        const result = await localStorage.getItem(assetTag)
        console.log(result)
        if(result === null){

            if(localStorage.length < 1) {
                const headerDataResponse = await sendGetRequest('/famas/header')
                const recordsData = await headerDataResponse.data[0].map((row)=>{return row})
                const finalRecords = []
                for(let i=0; i<recordsData.length; i++){
                    finalRecords.push({
                        data: recordsData[i]
                    })
                }
                finalRecords.map((row)=>{
                    localStorage.setItem(row.data.assetTag, JSON.stringify(row.data))
                    return true
                })
                const lineData = await sendGetRequest('famas-records-line')
                await lineData.data[0].map((row1)=> {
                    localStorage.setItem(row1.assetTag, JSON.stringify(row1))
                    return true
                })
                searchRecord()
            } else {
                setErrorDialog(true)
            }
            
        } else {
            setRecords(JSON.parse(result))
        }
    }

    // Sets the selected AssetTag, department, BU, source, and assignee
    // And pop the editDialog 
    function openEditRecord() {
        setSelectedAssetTag(records.asset_tag)
        setSelectedRemarks(records.remarks)

        if(records.header_id === undefined){
            setSelectedDepartment(records.department)
            setSelectedBU(records.business_unit)
            setSelectedSource(records.source)
            setSelectedAssignee(records.assignee)
            setEditDialog1(true)
        } else {
            setSelectedSerialNum(records.serial_no)
            setSelectedLocationID(records.location_id)
            setSelectedUOM(records.uom)
            setSelectedDescription(records.asset_desc)
            setSelectedStatus(records.asset_stat)
            setSelectedCost(records.acq_cost)
            setEditDialog2(true)
        }
    }

    const validateEntries = async () =>{

        let errMsg = [];
        let valid = true;

        if(_.isEmpty(selectedTms)){
            errMsg.push(<div key="error1"> <Typography> * "To " is a required field </Typography> </div>)
            valid = false;
        }

        if(_.isEmpty(selectedFrom)){
            errMsg.push(<div key="error1"> <Typography> * "From " is a required field </Typography> </div>)
            valid = false;
        }


        if(_.isEmpty(records.assetTag)){
            errMsg.push(<div key="error2"> <Typography> * "Asset Tag" is a required field </Typography> </div>)
            valid = false;
        }

        if(_.isEmpty(records.assetDesc)){
            errMsg.push(<div key="error3"> <Typography> * "Asset Description" is a required field </Typography> </div>)
            valid = false;
        }

        if(_.isEmpty(records.remarks)){
            errMsg.push(<div key="error4"> <Typography> * "Remarks" is a required field </Typography> </div>)
            valid = false;
        }

        if(_.isEmpty(records.offlineAction)){
            errMsg.push(<div key="error4"> <Typography> * "Action" is a required field </Typography> </div>)
            valid = false;
        }

        setErrorMessage(errMsg);
        return valid;
    }

    // Updates the FAMAS Header Record based on current data on selected 
    // AssetTag, department, BU, source, and assignee
    async function updateRecordInfo() {
        const valid = await validateEntries();
    
        if(!valid) {
            setErrorDialog(true);
            return;
        }
        
        
        let tempItem = JSON.parse(JSON.stringify(records));
        delete tempItem._id;
        delete tempItem._rev;

        let checkExistingItem = await famasDb.db.searchForProcessingByAssetTag(tempItem.assetTag);
        
        console.log("EXISTING", checkExistingItem);

        if(checkExistingItem.docs && checkExistingItem.docs.length > 0){
            alert("Item already exists under the 'FOR PROCESSING TAB'");

        }else{
            let res = await famasDb.db.createForProcessing(tempItem);
            if(res && res.ok){
                alert("Queued the FAMAS item for processing.")
                console.log(res);
            }
        }

        // if(!checkExistingItem){
        //     let res = await famasDb.db.createForProcessing(tempItem);
        //     if(res && res.ok){
        //         alert("Queued the FAMAS item for processing.")
        //         console.log(res);
        //     }
        // }else{
        //     alert("Item already exists under the 'FOR PROCESSING TAB'");
        // }

        setEditDialog1(false);
        return true;

        const bodyRequest = {
            id: records.id_master,
            assetTag: selectedAssetTag,
            assignee: selectedAssignee,
            businessUnit: selectedBU,
            department: selectedDepartment,
            source: selectedSource,
            updateDate: await new Date(),
            remarks: selectedRemarks
        }
        const result = await sendPostRequest('update-famas-record-header/' + records.id_master, bodyRequest)
        if(result.data.Status === "Success"){
            localStorage.clear()
            const headerDataResponse = await sendGetRequest('/famas/header')
            const recordsData = await headerDataResponse.data[0].map((row)=>{return row})
            const finalRecords = []
            for(let i=0; i<recordsData.length; i++){
                finalRecords.push({
                    data: recordsData[i]
                })
            }
            finalRecords.map((row)=>{
                localStorage.setItem(row.data.asset_tag, JSON.stringify(row.data))
                return true
            })
            const lineData = await sendGetRequest('famas-records-line')
            await lineData.data[0].map((row1)=> {
                localStorage.setItem(row1.asset_tag, JSON.stringify(row1))
                return true
            })
            setEditDialog1(false)
        }
    }

    async function updateRecordInfo2() {
        const bodyRequest = {
            id: records.id_master,
            assetTag: selectedAssetTag,
            serialNum: selectedSerialNum,
            locationID: selectedLocationID,
            uom: selectedUom,
            description: selectedDescription,
            status: selectedStatus,
            cost: selectedCost,
            remarks: selectedRemarks
        }
        const result = await sendPostRequest('update-famas-record-line/' + records.id_master, bodyRequest)
        console.log(result)
        if(result.data.Status === "Success"){
            localStorage.clear()
            const headerDataResponse = await sendGetRequest('/famas/header')
            const recordsData = await headerDataResponse.data[0].map((row)=>{return row})
            const finalRecords = []
            for(let i=0; i<recordsData.length; i++){
                finalRecords.push({
                    data: recordsData[i]
                })
            }
            finalRecords.map((row)=>{
                localStorage.setItem(row.data.asset_tag, JSON.stringify(row.data))
                return true
            })
            const lineData = await sendGetRequest('famas-records-line')
            await lineData.data[0].map((row1)=> {
                localStorage.setItem(row1.asset_tag, JSON.stringify(row1))
                return true
            })
            setEditDialog2(false)
        }
    }

    const openEditItem = async (e) =>{
        
        setEditDialog1(true);
        if(_.isEmpty(tms)){
            let resFind = await famasDb.db.getAllTms();

            console.log("SEARCH RESULTS", resFind);
            const items = [];

            
            const fetchedItems = Object.values(resFind);
            if(fetchedItems.length > 0){
                for(const item of fetchedItems){

                    if(item.empId && item.fullname){
                        items.push({id: item.empId, fullName: item.fullname});
                    }
    
                }
            }
        
            console.log("EMPLOYEE LIST", items);

            setTms(items);
        }
    }

    return(
        <React.Fragment>
           
            <Box m={4}>
                <TextField label='Asset Tag' onChange={(event)=>setAssetTag(event.target.value)} />
                <Button onClick={()=>startScan()}>Scan</Button>
                <Button onClick={()=>searchRecordLocal()}>Search</Button>
                {(!_.isEmpty(records)) && (<Button onClick={(e)=>openEditItem(e)}>Edit Record</Button>)}
            </Box>
            {
                records &&  !_.isEmpty(records) ?
                <React.Fragment>
                <Typography variant="subtitle1" gutterBottom>Note: This document is created by {records.createdBy} at {records.createdDate} </Typography>
                <Box m={3}>
                </Box>
                <Box m={3} p={2} component={Paper}>
                    <Typography variant="subtitle1" gutterBottom>Asset Tag: <b>{records.assetTag}</b></Typography>
                    <Typography variant="subtitle1" gutterBottom>Document Number: <b>{records.docNo}</b></Typography>
                    <Typography variant="subtitle1" gutterBottom>Department: <b>{records.department}</b></Typography>
                    <Typography variant="subtitle1" gutterBottom>Business Unit: <b>{records.businessUnit}</b></Typography>
                    <Typography variant="subtitle1" gutterBottom>Source:<b>{records.source}</b> Asignee:<b>{records.assignee}</b></Typography>
                </Box>
                <Box m={3} p={2} component={Paper}>
                    <Typography variant="subtitle1" gutterBottom>Issued By: </Typography>
                    <Typography variant="subtitle1" gutterBottom>Name: <b>{records.initApprv}</b></Typography>
                    <Typography variant="subtitle1" gutterBottom>Email: <b>{records.initEmail}</b></Typography>
                </Box>
                <Box m={3} p={2} component={Paper}>
                    <Typography variant="subtitle1" gutterBottom>Approved By: </Typography>
                    <Typography variant="subtitle1" gutterBottom>Name: <b>{records.finApprv}</b></Typography>
                    <Typography variant="subtitle1" gutterBottom>Email: <b>{records.finEmail}</b></Typography>
                </Box>
                <Box m={3} p={2}  component={Paper}>
                    <Typography variant="subtitle1" gutterBottom>Received By: </Typography>
                    <Typography variant="subtitle1" gutterBottom>Name: <b>{records.mmdApprv}</b></Typography>
                    <Typography variant="subtitle1" gutterBottom>Email: <b>{records.mmdEmail}</b></Typography>
                </Box>
                <Box m={3} p={2}  component={Paper}>
                    <Typography variant="subtitle1" gutterBottom>Remarks: </Typography>
                    <Typography variant="subtitle1" gutterBottom><b>{(records.remarks === null || records.remarks === '')  && ("None")}</b></Typography>
                    <Typography variant="subtitle1" gutterBottom><b>{records.remarks != null && (records.remarks)}</b></Typography>
                </Box>
                </React.Fragment>

                :null
            }
            
            <Dialog open={QRCodeReaderDialog} onClose={()=>setQRCodeReaderDialog(false)}>
                <DialogContent>
                    <QRCodeReader
                        delay={100}
                        onError={handleError}
                        onScan={scanQRCode}
                        style={{width: '30em'}}
                        />
                </DialogContent>
            </Dialog>

            <Dialog open={errorDialog} onClose={()=>{setErrorDialog(false); setErrorMessage();}}>
                <DialogTitle>Oooopppssss</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {
                            errorMessage
                        }
                    </DialogContentText>
                </DialogContent>
            </Dialog>

            <Dialog open={editDialog1} onClose={()=>setEditDialog1(false)}>
                <DialogTitle>FAMAS RECORD</DialogTitle>
                <DialogContent>
                    <Grid container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing = {3}
                    >
                        <Grid item xs={12} md={12}>
                            <TextField 
                            fullWidth
                            variant="outlined"
                            label="Asset Tag"
                            value={records.assetTag || ''}
                            onChange={(event)=>setSelectedAssetTag(event.target.value)}/>
                        </Grid>

                        <Grid item  xs={12} md={12}>
                            <BasicDropDown 
                                name="businessUnits" 
                                label="Business Units" 
                                options={businessUnits} value={records.businessUnit}
                                
                            />
                        </Grid>

                        <Grid item  xs={12} md={12}>
                            <BasicDropDown 
                                name="department" 
                                label="Department" 
                                options={departments} value={records.department}
                                
                            />
                        </Grid>
                        
                        <Grid item  xs={12} md={12}>  
                            <Autocomplete
                                onChange={(event, value) => {
                                    if(value){
                                        setSelectedTms(value);
                                        const items = [];
                                        for(let item of value){
                                            items.push({toUser: item.id});
                                        }
                                        
                                        setRecords({...records, toUser: JSON.stringify(items)});
                                    }
                                }} 
                                multiple
                                id="assignee"
                                options={tms}
                                value = {selectedTms}
                                getOptionLabel={(option) => option.fullName}
                                filterSelectedOptions
                                
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Assignee"
                                        placeholder="Assignee"
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item  xs={12} md={12}>
                            <Autocomplete
                                onChange={(event, value) => {
                                    if(value){
                                        setSelectedFrom(value);
                                        
                                    }
                                }} 
                                id="from"
                                options={tms}
                                value = {selectedFrom}
                                getOptionLabel={(option) => option.fullName}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="From"
                                        placeholder="From"
                                    />
                                )}
                            />
                        </Grid>

                        
                        
                        <Grid item  xs={12} md={12}>
                            <BasicDropDown 
                                name="plantSite" 
                                label="Plant Site" 
                                options={plantSite} value={records.plantSite}
                            />
                        </Grid>
                        <Grid item  xs={12} md={12}>
                            <BasicDropDown 
                                name="buildingStructure" 
                                label="Building Structure" 
                                options={buildingStructure} value={records.buildingStructure}
                            />
                        </Grid>
                        <Grid item  xs={12} md={12}>
                            <BasicDropDown 
                                name="room" 
                                label="room" 
                                options={room} value={records.room}
                            />
                        </Grid>
                        <Grid item  xs={12} md={12}>
                            <TextField 
                            fullWidth
                            multiline
                            rows = {4}
                            variant="outlined"
                            label="Remarks"
                            value={records.remarks}
                            onChange={(event)=>setRecords({...records, remarks: event.target.value})}/>
                        </Grid>
                        <Grid item  xs={12} md={12}>
                            <FormControl variant="outlined" fullWidth>
                            <InputLabel htmlFor="famasAction">Action:</InputLabel>
                            <Select
                            native
                            name = 'famasAction'
                            value={records.offlineAction}
                            onChange={(e)=>{setRecords({...records, offlineAction: e.target.value})}}
                            label="Action:"
                            inputProps={{
                                name: 'famasAction',
                                id: 'famasAction',
                            }}
                            >
                                <option aria-label="None" value="" />
                                <option value={'transferred'}>Transferred to your end</option>
                                <option value={'pulled'}>Pulled out from</option>
                                <option value={'cannibalized'}>Cannibalized from</option>
                                <option value={'sold'}>Sold per Inv/.OR#</option>
                                <option value={'retired'}>Retired</option>
                                <option value={'lost'}>Lost</option>
                                <option value={'donated'}>Donated</option>
                                <option value={'other'}>Other</option>
                            </Select>

                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>setEditDialog1(false)}>Cancel</Button>
                    <Button onClick={updateRecordInfo}>Update</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={editDialog2} onClose={()=>setEditDialog2(false)}>
                <DialogTitle>FAMAS ASSET</DialogTitle>
                <DialogContent>
                    <TextField 
                        fullWidth
                        variant="outlined"
                        label="Asset Tag"
                        value={selectedAssetTag}
                        onChange={(event)=>setSelectedAssetTag(event.target.value)}/>
                    <TextField 
                        fullWidth
                        variant="outlined"
                        label="Serial Number"
                        value={selectedSerialNum}
                        onChange={(event)=>setSelectedSerialNum(event.target.value)}/>
                    <TextField 
                        fullWidth
                        label="Location ID"
                        value={selectedLocationID}
                        onChange={(event)=>setSelectedLocationID(event.target.value)}/>
                    <TextField 
                        fullWidth
                        variant="outlined"
                        label="UOM"
                        value={selectedUom}
                        onChange={(event)=>setSelectedUOM(event.target.value)}/>
                    <TextField 
                        fullWidth
                        variant="outlined"
                        label="Description"
                        value={selectedDescription}
                        onChange={(event)=>setSelectedDescription(event.target.value)}/>
                    <TextField 
                        fullWidth
                        variant="outlined"
                        label="Status"
                        value={selectedStatus}
                        onChange={(event)=>setSelectedStatus(event.target.value)}/>
                    <TextField 
                        fullWidth
                        variant="outlined"
                        label="Cost"
                        value={selectedCost}
                        onChange={(event)=>setSelectedCost(event.target.value)}/>
                    <TextField 
                        fullWidth
                        variant="outlined"
                        label="Remarks"
                        value={selectedRemarks}
                        onChange={(event)=>setSelectedRemarks(event.target.value)}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>setEditDialog2(false)}>Cancel</Button>
                    <Button onClick={updateRecordInfo2}>Update</Button>
                </DialogActions>
            </Dialog>

    </React.Fragment>       
)}

export default SearchRecords